import { AdminActionService } from "./admin-actions.service";
import { AuthService } from "./auth.service";
import { CarriersService } from "./carriers.service";
import { HelpTicketService } from "./help-ticket.service";
import { IAMService } from "./iam.service";
import { MappersService } from "./mappers.service";
import { MembershipsService } from "./memberships.service";
import { ReportConfigService } from "./report-configs.service";
import { StateService } from "./state.service";
import { TenantsService } from "./tenants.service";
import { UsersService } from "./users.service";

export const usersService = new UsersService();
export const iamService = new IAMService();
export const tenantsService = new TenantsService();
export const carriersService = new CarriersService();
export const mappersService = new MappersService();
export const authService = new AuthService();
export const membershipService = new MembershipsService();
export const helpTicketService = new HelpTicketService();
export const reportConfigService = new ReportConfigService();
export const stateService = new StateService();
export const adminActionService = new AdminActionService();
